import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import GsapFx from './components/GsapFx';
import Cursor from './components/Cursor';
import ScrollProgress from './components/ScrollProgress';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Stats from './components/Stats';
import Services from './components/Services';
import AIProjects from './components/AIProjects';
import Process from './components/Process';
import Benefits from './components/Benefits';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <GsapFx />
      <Cursor />
      <ScrollProgress />
      <Navbar />
      <Hero />
      <Marquee />
      <Stats />
      <Services />
      <AIProjects />
      <Process />
      <Benefits />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
